<a class="header__logo logo logo_header link" routerLink="/" aria-label="main">
  <span class="logo__circle"></span>
  <span class="logo__arrow logo__arrow_small"></span>
  <span class="logo__arrow logo__arrow_big"></span>
  <!--  <div class="logo__xmas"></div>-->
  <span class="logo__text"></span>
</a>

<div class="header__menu menu">
  <div class="menu__buttons">
    <a
      class="group flex h-[4.4rem] items-center justify-start space-x-[0.6rem] overflow-hidden rounded-[1rem] bg-[linear-gradient(207deg,#38A0D0_-10.19%,#609AFF_80.05%)] px-[1.2rem] text-[#DBE7FF] !outline-none custom-transition-text custom-transition-bg before:bg-[linear-gradient(207deg,#4BB8EA_-10.19%,#82B0FF_80.05%)] hover:text-white lg:hidden"
      routerLink="/raffles"
      aria-label="raffles"
    >
      <i class="icon icon_raffles text-[2.4rem] !text-white"></i>
      <div class="flex flex-1 items-center justify-center">
        <span class="text-center text-[1.3rem] font-400" i18n="@@raffles.main.title"> Розыгрыши </span>
      </div>
    </a>
  </div>
</div>

<div class="header__profile profile-header">
  @if (!authState.user()) {
    <ui-login-button class="profile-header__login" [allowDialogAutoOpen]="true" />
  }

  @if (authState.user(); as loggedUser) {
    <div class="profile-header__user-actions">
      @if (loggedUser.wager && !isLg()) {
        @defer (on immediate) {
          <shell-wager-bonus [wager]="loggedUser.wager" [wagerBalance]="loggedUser.wagerBalanceUsd" />
        }
      }
      <div class="profile-header__deposit deposit">
        <span
          class="deposit__bank"
          [convert]="loggedUser.balanceUsd"
          [convertAnimation]="true"
          convertDigits="1.2-2"
        ></span>
        <div class="flex items-center justify-center space-x-[0.4rem]">
          <a class="deposit__button btn btn_green" (click)="navigateToPayment()">
            <span class="btn__text" i18n="@@header.balance_menu.deposit">Пополнить</span>
          </a>
          <a class="withdrawal__button btn btn_green-bordered" (click)="navigateToPayment(true)">
            <span class="btn__text" i18n="@@header.balance_menu.withdrawal">Вывод</span>
          </a>
        </div>
      </div>

      <a
        class="profile-header__picture picture"
        routerLink="/profile"
        [ngClass]="loggedUser.nicknameColor | userPictureColor"
      >
        <img
          loading="lazy"
          class="image"
          [src]="loggedUser | userAvatar"
          [alt]="loggedUser.nickname"
          fetchpriority="low"
        />

        <div class="profile-header__level badge" [ngClass]="loggedUser.level | levelColor">
          {{ loggedUser.level }} lvl
        </div>
      </a>
    </div>
  }

  <div class="header__actions">
    @if (authState.user()) {
      @defer (on immediate) {
        <notifications-container class="header__notifications" />
      } @loading {
        <button class="notifications-toggler btn" aria-label="notifications" type="button">
          <i class="icon icon_new icon_notify"></i>
        </button>
      } @placeholder {
        <button class="notifications-toggler btn" type="button" aria-label="notifications">
          <i class="icon icon_new icon_notify"></i>
        </button>
      }
    }

    @if (!isLg() && authState.user()) {
      @defer (on immediate) {
        <buffs-active-container class="header__notifications" />
      } @loading {
        <button class="notifications-toggler btn" aria-label="notifications" type="button">
          <i class="icon icon_new icon_doc"></i>
        </button>
      } @placeholder {
        <button class="notifications-toggler btn" aria-label="notifications" type="button">
          <i class="icon icon_new icon_doc"></i>
        </button>
      }
    }

    <button type="button" class="header__settings btn" aria-label="settings" (click)="openSettingsDialog()">
      <i class="icon_new icon_setting !text-[2.2rem] !text-light-200"></i>
    </button>

    @if (isLg()) {
      <shell-header-burger-menu [isLogged]="authState.isAuthenticated()" />
    }
  </div>

  <!-- <div class="flex flex-col items-end justify-center ml-[1.4rem] sm:hidden">
    <div class="flex items-center justify-center space-x-[0.5rem]">
      <div class="bg-[#FFDB95] w-[0.6rem] h-[0.6rem] rounded-full"></div>
      <span class="text-[#FDD291] text-[1.6rem] leading-[1.92rem] font-semibold">13 300</span>
    </div>
    <div class="text-[#97A9D6] text-[1rem] leading-[1.2rem] font-light uppercase">ONLINE</div>
  </div> -->
</div>
